export default {
  "logoImages": [
    {
      "imgUrl": "https://webimage.tongxinyiliao.com/patientPlateForm/guokang/bannerOne.png",
      "url": ""
    },
  ],
  "reservationEEG": {
    "style": "background-color:#44c1ec80",
    "bgImgUrl": 'https://webimage.tongxinyiliao.com/patientPlateForm/tongxin/EEGBanner.png'
  },
  "service": {
    "address": "",
    "phone": ""
  },
  "newsList": [
    {
      'title': '花粉过敏，难受到一直“哭鼻子”，怎么破？',
      'desc': '春季的空气里总是酝酿着一些氤氳的气息，盛放的鲜花，享受着阳光，生活可以如此的绚烂,可是过敏偏偏要跟人们作对。不要担心，预防过敏的小知识已经安排上啦！',
      'thumbnail': 'http://webimage.tongxinyiliao.com/patientPlateForm/tongxin/flowerGm.jpg',
      'linkUrl': 'https://mp.weixin.qq.com/s/71cFpud2yz2Tp1GvC8SFJg',
    },
    {
      'title': '远离中风1年复发魔咒？教你排查高危因素',
      'desc': '“脑卒中”又称“中风”、“脑血管意外”。是一种急性脑血管疾病，是由于脑部血管突然破裂或因血管阻塞导致血液不能流入大脑而引起脑组织损伤的一组疾病，包括缺血性和出血性卒中。据统计显示，每12秒即有一个中国人发生脑卒中，每21秒就有一个中国人死于脑卒中，脑卒中已然成为中国居民第一位死因。脑卒中具有发病率高、死亡率高和致残率高的特点。',
      'thumbnail': 'http://webimage.tongxinyiliao.com/patientPlateForm/tongxin/stork.jpg',
      'linkUrl': 'https://mp.weixin.qq.com/s/6Jrv5s1C6e1mlspYR1CNQw'
    },
    {
      'title': '血液黏稠就是血脂高吗？听听专业医生怎么说~',
      'desc': '心脑血管疾病是导致人群死亡和生活质量下降的主要疾病之一，且发病率有逐年升高的趋势。血脂异常是心脑血管疾病的主要危险因素，那么你关注过自己的血脂吗？',
      'thumbnail': 'http://webimage.tongxinyiliao.com/patientPlateForm/tongxin/bloodNc.jpg',
      'linkUrl': 'https://mp.weixin.qq.com/s/CbG7ejyv1haYEr6bID9S8g'
    },
    {
      'title': '肠道总是闹脾气，最简单的清肠养胃法看这里~',
      'desc': '皮肤长斑、腹胀便秘、脸上长包……受到这些问题困扰时，你会不会首先想到可能是肠道出问题了？调查显示，我国有70%以上的人肠道年龄普遍大于实际年龄10岁。一些错误的生活方式和“排毒”方式，会让肠道受损早衰，甚至8周就会“变黑”。',
      'thumbnail': 'http://webimage.tongxinyiliao.com/patientPlateForm/tongxin/intestinal.jpg',
      'linkUrl': 'https://mp.weixin.qq.com/s/e6BoumYIk0HNye0dCAmdZw'
    },
    {
      'title': '血常规报告单你可看的懂？一项一项教您，秒懂',
      'desc': '血常规的检查方法有两种：人工显微镜计数法法和血常规分析仪法。目前各大医院都采用仪器法。不同的仪器检测项目数量稍有不同，越高端的仪器检测项目越多。',
      'thumbnail': 'http://webimage.tongxinyiliao.com/patientPlateForm/tongxin/routineBlood.jpg',
      'linkUrl': 'https://mp.weixin.qq.com/s/MR2lFePmEocKTYRzvWiuvA'
    },
    {
      'title': '难难难，去医院开个药咋就这么难？便捷通道看这里！',
      'desc': '排队挂号，排队交费，排队取药，每月都得请假一天，工资没了，还把大把的时间浪费到了等待上。老年慢性病患者，腿脚不利索。每次去医院复诊，儿女不放心，还得需要他们请一天的假，全程陪着，其实无非就是定期开点药。',
      'thumbnail': 'http://webimage.tongxinyiliao.com/patientPlateForm/tongxin/hosiHard.jpg',
      'linkUrl': 'https://mp.weixin.qq.com/s/8UkI55H1HiRBpoe0RoGKhw'
    },
    {
      'title': '心电图可不能白做！附检查注意事项及诊断要点',
      'desc': '心内科医生有个探案“法宝”——心电图，这项简单、无创、经济的检查，在心律失常的诊断与治疗中起着重要的作用。这也是我们进行心脏检查时常常遇到的检查项目之一。',
      'thumbnail': 'http://webimage.tongxinyiliao.com/patientPlateForm/tongxin/ecg.jpg',
      'linkUrl': 'https://mp.weixin.qq.com/s/2iM41kE4GO3ef5COdYnRvw'
    },
    {
      "title": "秋高气爽却哈欠连天，四招拯救您的秋乏",
      "desc": "俗话说“春困秋乏”，秋季是最容易使人乏累的季节，秋天一到，整个人经常会有昏昏沉沉的感觉，想要解除秋乏的困扰，不妨试试下面这些方法。",
      "thumbnail": "http://webimage.tongxinyiliao.com/patientPlateForm/tongxin/newsOne.jpeg",
      "linkUrl": "https://mp.weixin.qq.com/s/Sm7VwMOihxgSOrs-IWEgJg"
    },
    {
      "title": "癫痫病减药、停药有哪些注意事项？",
      "desc": "癫痫病减药前复查脑电图，停药前再次复查脑电图。多数癫痫综合征需要脑电图完全无癫痫样放电再考虑减停药物，而且减药过程中需要定期（每 3-6 个月）复查长程脑电图，如果减停药过程中再次出现癫痫样放电，需要停止减量；",
      "thumbnail": "https://webimage.tongxinyiliao.com/patientPlateForm/tongxin/newsTwo.jpeg",
      "linkUrl": "https://mp.weixin.qq.com/s/skW068_LjgBgnEOZiD_Hpw"
    },
    {
      "title": "癫痫患者能不能通过手术治愈？",
      "desc": "近期，在我们诊室很多患者患者会问一个问题，那就是“癫痫能不能通过手术达到彻底治愈的效果”，下面我就针对这个问题，总结并且给大家统一回复一下。",
      "thumbnail": "https://webimage.tongxinyiliao.com/patientPlateForm/tongxin/newsThree.jpeg",
      "linkUrl": "https://mp.weixin.qq.com/s/8CaUxgE-K-igt9_fB30s9g"
    },
    {
      "title": "癫痫病患者的自我管理须知",
      "desc": "癫痫病与所有的慢性病一样，患者需长期服药治疗，并且对于癫痫病发作病人来说，采用药物治疗的确比其他治疗方式更有效、更安全、更可靠。药物治疗不仅要遵医嘱，更多的是患者对自身的约束和管理。那么患者在药物治疗中需要注意哪些方面呢？",
      "thumbnail": "https://webimage.tongxinyiliao.com/patientPlateForm/tongxin/newsFour.png",
      "linkUrl": "https://mp.weixin.qq.com/s/EQdiKkTJqKkChz2Sv0ZLQA"
    }
  ]
}